import api from '@edu-fe/api'
import os from '@edu-fe/os'
import Cookie from 'js-cookie'

export default {
  name: 'media',
  getMediaData: api.create('/course/chapter_detail'),
  getCommentData: api.create(`/comment/list/v2?userId=${Cookie.get('openid')}`),
  sendComment: api.create(`/comment/post?userId=${Cookie.get('openid')}`, { method: 'post' }),
  checkSignStatus: api.create('/course/is/sign'),
  sign: api.create('/course/signin', { method: 'post', formData: true }),
  hasBuy: (courseId) => api.create(`/my/is/buy?courseId=${courseId}&type=1&userId=${Cookie.get('openid')}`),
}
